const prefix = '[event/teams]'

export const LOAD_REQUEST = `${prefix} LOAD/REQUEST`
export const LOAD_SUCCESS = `${prefix} LOAD/SUCCESS`
export const LOAD_ERROR = `${prefix} LOAD/ERROR`

export const TEAM_CREATED = `${prefix} CREATE/SUCCESS`
export const TEAM_UPDATED = `${prefix} UPDATE/SUCCESS`
export const TEAM_DELETED = `${prefix} DELETE/SUCCESS`
